module.exports = __webpack_public_path__ + "assets/img/rider.13dc6e45.gif";